import React from 'react';
import { styles } from './Disclaimer.css';

export type DisclaimerProps = {
  disclaimers: Array<string>;
};

export const Disclaimer = ({ disclaimers }: DisclaimerProps) => {
  return (
    <div>
      {disclaimers.map((disclaimer, i) => (
        <p className={styles.text} key={i}>
          {disclaimer}
        </p>
      ))}
    </div>
  );
};
